import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, ChildrenOutletContexts, NavigationEnd, ResolveEnd, Router, RouterOutlet} from "@angular/router";
import {slideInAnimation} from "./step.animations";
import {filter} from "rxjs/operators";
import {Subscription} from "rxjs";
import {StepService} from "../services/step.service";
import {PortalService} from "../services/portal.service";

/**
 * Generic component for holding severeal steps as one chapter.
 */
@Component({
    templateUrl: './step.chapter.component.html',
    selector: 'app-chapter',
    animations: [
        slideInAnimation
    ],
    standalone: false
})
export class StepChapterComponent implements OnInit, OnDestroy {
  /**
   * Alle subscriptions of the chapter should be stored here to unsubscribe them after the component ist destroyed.
   */
  subscriptions: Subscription[] = [];

  /**
   * Element of the step wrapper
   */
  @ViewChild('stepWrapper') stepWrapper: ElementRef;

  /**
   * The current height of the component
   */
  componentHeight: number;

  /**
   * constructor.
   * @param router
   * @param route
   * @param stepService
   * @param portalService
   * @param contexts
   */
  constructor(protected router: Router, protected route: ActivatedRoute, protected stepService: StepService,
              protected portalService: PortalService, protected contexts: ChildrenOutletContexts) {
    // subscribe for changes on the subroutes and extract the prev/next steps with the stepService
    this.subscriptions.push(this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
    ).subscribe(() => {
      this.stepService.extractSteps(this.route.snapshot);
      // update the min height after the animation stops.
      setTimeout(() => this.updateHeight(), 500);
    }));
  }

  /**
   * @inheritDoc
   */
  ngOnInit() {
    // initially extract the steps.
    this.subscriptions.push(this.route.url.subscribe(() => {
      this.stepService.extractSteps(this.route.snapshot);
    }));

    // set the min height initially
    this.updateHeight();

    // if the stepheight changes, update the min height
    this.stepService.heightChanged.subscribe(() => this.updateHeight());
  }

  /**
   * @inheritDoc
   */
  ngOnDestroy() {
    // unsubscribe all subscriptions
    this.subscriptions.map(subscription => subscription.unsubscribe());
  }

  /**
   * helper function for the routing animations between the steps
   */
  prepareRoute() {
    return this.contexts.getContext('primary')?.route?.snapshot?.data?.swipeCount;
  }

  /**
   * Update the height of the currect element, based on the child height.
   */
  updateHeight(): void {
    this.componentHeight = 400;
    setTimeout(() => {
      this.componentHeight = this.stepWrapper?.nativeElement.offsetHeight;
    }, 100);
  }


}
